export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0 bg-background-900">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20golden%20spotlight%20and%20deep%20crimson%20velvet%20curtain%20textures%2C%20luxurious%20theater%20atmosphere%2C%20elegant%20art%20deco%20cinema%20architectural%20elements%2C%20soft%20bokeh%20lights%2C%20dark%20rich%20background%20with%20dramatic%20contrast%2C%20high%20end%20editorial%20photography%20style%2C%20mysterious%20and%20inviting%20warm%20ambiance&width=1600&height=900&seq=hero-bg-cinema-01&orientation=landscape"
          alt="蓝莓影院影视氛围背景"
          className="w-full h-full object-cover"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-primary-500/20 text-primary-300 border border-primary-500/30 mb-5">
              🔥 全网热播 每日更新
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              蓝莓影院 · 海量电视剧全集
              <br className="hidden sm:block" />
              免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-body mb-3">
              追剧不等待，高清不缓冲
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              蓝莓影院专注收录全网热门电视剧，从最新开播的热门大剧到经典回忆老剧，每日同步更新，
              支持高清流畅播放，无需注册即可免费在线观看。无论你喜欢古装仙侠、都市情感还是悬疑推理，
              海量电视剧大全满足你所有追剧需求。热门新剧上线即更，经典老剧随时重温，畅享不缓冲的观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">20000+</div>
                <div className="text-xs text-white/55 mt-1">收录剧集</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-white/55 mt-1">50+ 集同步</div>
              </div>
              <div className="w-px h-8 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-400 font-heading">1080P</div>
                <div className="text-xs text-white/55 mt-1">高清画质</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm whitespace-nowrap cursor-pointer transition-colors text-center"
              >
                开始追剧
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3 rounded-md border border-white/30 hover:border-white/60 text-white font-medium text-sm whitespace-nowrap cursor-pointer transition-colors text-center"
              >
                浏览热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20Chinese%20cinema%20poster%20style%20composition%20with%20dramatic%20spotlight%20on%20a%20classic%20film%20reel%20and%20golden%20theater%20curtains%2C%20vintage%20movie%20poster%20aesthetic%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20artistic%20silhouette%20of%20audience%20in%20theater%2C%20warm%20atmospheric%20lighting%2C%20luxurious%20cinema%20design%2C%20soft%20textured%20background&width=600&height=750&seq=hero-visual-cinema-02&orientation=portrait"
                alt="蓝莓影院主视觉 - 高清电视剧在线观看"
                className="w-full h-auto object-cover rounded-lg"
              onError={(e) => {
                  (e.currentTarget as HTMLImageElement).parentElement!.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 rounded-lg ring-1 ring-inset ring-white/10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}